export function secureRandom() {
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    const a = new Uint32Array(1)
    window.crypto.getRandomValues(a)
    return a[0] / 2 ** 32
  }
  return 0.5
}